import Fab, { FabProps } from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import { MdiReactIconComponentType } from 'mdi-react/';
import React from 'react';

interface IProps extends Partial<FabProps> {
  actions: {
    icon: MdiReactIconComponentType,
    tooltip?: string;
    onClick: () => void;
  }[];
}

const FabButton = (props: IProps) => {
  const { actions, ...fabProps } = props;

  if (actions.length > 1) {
    return (<div></div>);
  }

  const action = actions[0];
  return (
    <div className={'header-app'}>
      {action.tooltip &&
        <Tooltip title={action.tooltip}>
          <Fab color='primary' {...fabProps} onClick={action.onClick}>
            <action.icon />
          </Fab>
        </Tooltip>
      }

      {!action.tooltip &&
        <Fab color='primary' {...fabProps} onClick={action.onClick}>
          <action.icon />
        </Fab>
      }
    </div>
  );
};

export default FabButton;